import {
  Button,
  ButtonColor,
  disabledQuery,
  loadNavContext,
  MainLayout,
  useMe,
  useOrganizationInfo
} from "@quortex/front-common"
import { useNavigate } from "@tanstack/react-location"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import { useAccountCreation } from "src/stores/AccountCreation"
import FinishedStep from "../AccountCreation/FinishedStep"

const PendingOrganization = () => {
  const { setOnAccountCreationProcess, onAccountCreationProcess } = useAccountCreation(
    store => store
  )
  const navigate = useNavigate()

  const { data: me } = useSuspenseQuery(useMe())
  const { previousOrgUuid } = loadNavContext(me)
  const previousOrgQuery = useOrganizationInfo({ orgUuid: previousOrgUuid })
  const { data: previousOrg } = useSuspenseQuery(previousOrgUuid ? previousOrgQuery : disabledQuery)
  const { data: currentOrg } = useSuspenseQuery(useOrganizationInfo())

  // biome-ignore lint/correctness/useExhaustiveDependencies: -
  useEffect(() => {
    if (onAccountCreationProcess) {
      setOnAccountCreationProcess(false)
    }
  }, [])

  useEffect(() => {
    if (currentOrg?.creationStatus !== "pending") {
      navigate({ replace: true, to: `/organizations/${currentOrg.uuid}` })
    }
  }, [currentOrg, navigate])

  return (
    currentOrg?.creationStatus === "pending" && (
      <MainLayout>
        <div className="flex h-full items-center justify-center bg-white p-20">
          <div className="flex flex-col items-center gap-20">
            <FinishedStep />
            {previousOrg && (
              <Button
                color={ButtonColor.PRIMARY}
                to={`/organizations/${previousOrgUuid}`}
                type="link"
              >
                Go back to <strong>“{previousOrg?.name}”</strong> organization
              </Button>
            )}
          </div>
        </div>
      </MainLayout>
    )
  )
}

export default PendingOrganization
